<img *ngIf="useAssetsPath; else crsImage" [src]="'assets/internal-error.svg'" alt="Internal error" />
<ng-template #crsImage>
	<img obgImageContent="internal-error.image" />
</ng-template>

<h1 class="title">{{ "internal-error.title" | translate }}</h1>

<p [innerHtml]="'internal-error.body' | translate"></p>

<div class="button-container">
	<button *ngIf="isRefreshVisible" class="refresh-button" (click)="refresh()">
		{{ "internal-error.refresh" | translate }}
	</button>
	<a *ngIf="customerSupportUrl$ | async as customerSupportUrl" [href]="customerSupportUrl" target="_blank">{{
		"customer-support.title" | translate
	}}</a>
</div>
